import { Skeleton } from '@mui/material';

const CreatorSkeleton = () => (
  <div className="flex items-center p-2 py-4 flex-col lg:flex-row border-b">
    {/* Main Creator Info Section */}
    <div className="w-full lg:w-2/3">
      <div className="flex flex-wrap w-full">
        {/* Avatar and buttons section */}
        <div className="flex w-full md:w-2/3 gap-4">
          <div className="flex gap-2 w-1/3 lg:w-1/4">
            <div className="flex flex-col gap-2">
              <Skeleton variant="rectangular" width={32} height={32} />
            </div>
            <Skeleton variant="circular" width={140} height={140} />
          </div>
          {/* Name and details */}
          <div className="w-2/3 lg:w-3/4">
            <div className="flex flex-col gap-2">
              <Skeleton variant="text" width="80%" height={28} />
              <Skeleton variant="text" width="40%" height={20} />
              <Skeleton variant="rectangular" width="60%" height={24} className="mt-2" />
              <div className="flex gap-1 mt-2">
                <Skeleton variant="rectangular" width={80} height={32} />
                <Skeleton variant="rectangular" width={100} height={32} />
              </div>
            </div>
          </div>
        </div>
        {/* Socials and collabs section */}
        <div className="w-full md:w-1/3 py-2 md:py-0 mt-4 md:mt-0">
          <div className="flex flex-col gap-2">
            <Skeleton variant="text" width={60} height={16} />
            <div className="flex gap-1 flex-wrap">
              <Skeleton variant="rectangular" width={32} height={32} />
              <Skeleton variant="rectangular" width={32} height={32} />
              <Skeleton variant="rectangular" width={32} height={32} />
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Posts section - hidden on mobile */}
    <div className="w-full hidden lg:w-1/3 lg:block lg:pl-4">
      <div className="flex gap-2">
        <Skeleton variant="rectangular" width={120} height={120} />
        <Skeleton variant="rectangular" width={120} height={120} />
        <Skeleton variant="rectangular" width={120} height={120} />
      </div>
    </div>
  </div>
);

export const CreatorListSkeleton = () => (
  <>
    <CreatorSkeleton />
    <CreatorSkeleton />
    <CreatorSkeleton />
    <CreatorSkeleton />
    <CreatorSkeleton />
  </>
);
